/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sponsor_Edit_UnresolvedInputs */



/**
* | output |
* | --- |
* | "unknown member" |
*
* @param {Sponsor_Edit_UnresolvedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sponsor_edit_unresolved = /** @type {((inputs?: Sponsor_Edit_UnresolvedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sponsor_Edit_UnresolvedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("membre inconnu")
	if (locale === "es") return /** @type {LocalizedString} */ ("miembro desconocido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("membro desconhecido")
	if (locale === "it") return /** @type {LocalizedString} */ ("membro sconosciuto")
	return /** @type {LocalizedString} */ ("unknown member")
});